export default {
  CANCEL_SUBSCRIPTION_PAGE: 'cancel-subscription-page',
  CANCEL_BUTTON: 'cancel-button',
  FAILED_PAYMENT_METHOD: 'failed-payment-method',
  EXPIRED_PAYMENT_METHOD: 'expired-payment-method',
  EXPIRY_SOON_PAYMENT_METHOD: 'expiry-soon-payment-method',
};
